import { formatMomentToValueDate } from '../../helpers/formatMomentToValueDate';
import { formatValueDateToMoment } from '../../helpers/formatValueDateToMoment';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export const goToPrevMonth = (date: values.v1.Date): values.v1.Date => {
  const prevMonthMoment = formatValueDateToMoment(date)
    .startOf('month')
    .subtract(1, 'month')
    .startOf('week');
  return formatMomentToValueDate(prevMonthMoment);
};
